import { request } from 'sonata-react-components';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

export async function fetchBaseCurrency(
  currencyCode: string,
  token?: Record<string, any>
): Promise<BaseCurrencyInterface> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}baseCurrency/${currencyCode}`,
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET'
    },
    token
  );
}

export const fetchBaseCurrencyByUser = async (
  userId: string,
  token?: Record<string, any>
): Promise<Record<string, any>> => {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}baseCurrency/user/${userId}`,
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET'
    },
    token
  );
};
